/**
 * @file index.tsx
 *
 * @fileoverview Renders login modal.
 */

import LoginForm, {
  LoginFormProps,
} from '~/jobiqo/components/User/Login/components/Form';
import { Modal } from '~/vcl/atoms/15-modal';

interface LoginModalProps extends LoginFormProps {
  /**
   * Show modal flag.
   */
  isShown: boolean;
  /**
   * On modal hide callback.
   */
  onHide: () => void;
}

export const LoginModal = ({ onLoginSuccess, ...rest }: LoginModalProps) => {
  return (
    <Modal showClose={true} {...rest}>
      <LoginForm onLoginSuccess={onLoginSuccess} />
    </Modal>
  );
};

export default LoginModal;
